<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/glory.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
    <!-- <div class="main-box"> -->
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
                <div style="height:55px;"></div>
                <div :class="$i18n.locale=='zh'?'zh-font':'en-font'">{{$t('glory.content1')}}</div>
                <div style="height:20px;"></div>
                <div class="content">
                    <div class="content-item1">
                        <img src="../../assets/images/CRSAS.png" ref="element" >
                        <div class="item-text">{{$t('glory.card[0]')}}</div>
                    </div>
                    <div class="content-item1">
                        <img src="../../assets/images/iec27001-1.png">
                        <div class="item-text">{{$t('glory.card[1]')}}</div>
                    </div>
                    <div class="content-item1">
                        <img src="../../assets/images/iec27001.png">
                        <div class="item-text">{{$t('glory.card[2]')}}</div>
                    </div>
                </div>
                <div style="height:20px;"></div>
                <div class="content">
                    <div class="content-item1">
                        <img src="../../assets/images/ISO45001.png">
                        <div class="item-text">{{$t('glory.card[3]')}}</div>
                    </div>
                    <div class="content-item1">
                        <img src="../../assets/images/ISO14001.png">
                        <div class="item-text">{{$t('glory.card[4]')}}</div>
                    </div>
                    <div class="content-item1">
                        <img src="../../assets/images/ISO9001.png">
                        <div class="item-text">{{$t('glory.card[5]')}}</div>
                    </div>
                </div>
                <div style="height:20px;"></div>
                <div class="content2">
                    <div class="content-item2">
                        <img src="../../assets/images/msdscard.png">
                        <div class="item-text">{{$t('glory.card[15]')}}</div>
                    </div>
                    <div class="content-item2">
                        <img src="../../assets/images/carcheck.png">
                        <div class="item-text">{{$t('glory.card[16]')}}</div>
                    </div>
                    <div class="content-item2">
                        <img src="../../assets/images/ncmcard.png">
                        <div class="item-text">{{$t('glory.card[17]')}}</div>
                    </div>
                </div>
                <div style="height:20px;"></div>
                <div class="content3">
                    <!-- <div class="content-item2">
                        <img src="../../assets/images/semi.png">
                        <div class="item-text">{{$t('glory.card[20]')}}</div>
                    </div> -->
                    <div class="content-item3">
                        <img src="../../assets/images/zhengming.jpg">
                        <div class="item-text">{{$t('glory.card[19]')}}</div>
                    </div>
                </div>
                <!-- <div class="content">
                    <div class="content-item2">
                        <img src="../../assets/images/basiluofu.png">
                        <div class="item-text">{{$t('glory.card[6]')}}</div>
                    </div>
                    <div class="content-item2">
                        <img src="../../assets/images/akesu.png">
                        <div class="item-text">{{$t('glory.card[7]')}}</div>
                    </div>
                    <div class="content-item2">
                         <img src="../../assets/images/bihai.png">
                        <div class="item-text">{{$t('glory.card[8]')}}</div>
                    </div>
                    <div class="content-item2">
                         <img src="../../assets/images/qiangsheng.png">
                        <div class="item-text">{{$t('glory.card[9]')}}</div>
                    </div>
                    <div class="content-item2">
                         <img src="../../assets/images/yishiman.png">
                        <div class="item-text">{{$t('glory.card[10]')}}</div>
                    </div>
                </div> -->
                <div style="height:20px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default({
    data() {
        return {
            height: "auto"
        }
    },
    mounted() {
        this.$nextTick(()=>{
            if(this.$refs.element.offsetHeight != 0) {
                this.height =  this.$refs.element.offsetHeight + 'px'
            }
        })
    }
})
</script>

<style scoped>
    .inner-pannel{
        min-height: 100%;
        padding-bottom: 150px;
        position: static;
        /* position: relative; */
        /* position: absolute; */
        top: 0;
        width: 100%;
        font-family: 'Lato','Microsoft JhengHei';
    }
    .content{
        display: flex;
        /* justify-content: space-between; */
    }
    .content2{
        display: flex;
        justify-content: start;
    }
    .content3{
        display: flex;
        justify-content: start;
    }
    .item-text{
        text-align: center;
    }
    .content-item1{
        text-align: center;
        width: calc((100% - 200px)/4);
        margin-right: 50px;
    }
    .content-item2{
        text-align: center;
        /* width: calc((100% - 240px)/5); */
        width: calc((100% - 200px)/4);
        margin-right: 50px;
    }
    .content-item3{
        text-align: center;
        width: 44%;
        /* margin-left: 48px; */
        /* height: calc(100% - 62.5px); */
    }
    .content-item1 img{
        width: 100%;
    }
    .content-item2 img{
        width: 100%;
    }
    .content-item3 img{
        width: 100%;
    }
    .line-box{
        display: block;
        margin-top: 8px;
        width: 55%;
        border-bottom: 1px solid #ffffff;
    }
    .main{
        margin: 8px 0;
    }
    .topPoint::after {
        width: 25px;
        height: 25px;
        content: "";
        position: absolute;
        background: #ed6d00;
        border-radius: 50%;
        z-index: 1;
        top: -12.5px;
        right: -12.5px;
    }
    @media screen and (max-width:768px) {
        .content{
            justify-content: space-between;
        }
        .content-item1{
            width: calc((100% - 20px)/3);
            margin-right: 0;
        }
        .content2{
            justify-content: space-between;
        }
        .content-item2{
            width: calc((100% - 20px)/3);
            margin-right: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/qualifications/qualifications.vue